<template class="d-flex">
    <dx-data-grid
        style="flex-grow: 1"
        :data-source="dataSource"
        :remote-operations="false"
        :allow-column-reordering="true"
        :row-alternation-enabled="true"
        :show-column-lines="true"
        :show-borders="true"
        :height="50"
        :width="'100%'"
        :column-min-width="150"
        :word-wrap-enabled="true"
    >
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />
        <dx-export :enabled="true" :formats="['pdf', 'excel']" :allow-export-selected-data="true" />

        <dx-toolbar>
            <dx-item
                location="before"
                template="objectTypeTemplate"
            />

            <dx-item
                widget="dxButton"
                location="after"
                name="refresh"
            >
                <dx-button
                    hint="Обновить"
                    icon="refresh"
                    @click="reloadData(false)" />
            </dx-item>
        </dx-toolbar>

        <dx-column
            data-field="kod"
            data-type="number"
        />

        <dx-column
            caption="Тип объекта"
            data-field="type_obj"
            data-type="number"
        >
            <dx-lookup
                :data-source="objetsList"
                value-expr="id"
                display-expr="name"
            />
        </dx-column>

        <dx-column
            caption="Работа (ЛЭ/Заявитель)"
            data-field="pr_work_abon"
            data-type="number"
        >
            <dx-lookup
                :data-source="workOwnerList"
                value-expr="id"
                display-expr="name"
            />
        </dx-column>

        <dx-column
            v-for="(item, index) in charactersLit"
            :key="index"
            :caption="item.description"
            :data-field="`work_value__${item.field_name}`"
            data-type="string"
            :min-width="200"
        >
        </dx-column>

        <dx-column
            caption="Ручной ввод"
            data-field="pr_hand"
            data-type="boolean"
            :min-width="80"
        />

        <dx-column
            caption="Работа"
            data-field="kod_work"
            data-type="number"
            :min-width="250"
        >
            <dx-lookup
                :data-source="worksList"
                value-expr="id"
                display-expr="name"
            />
        </dx-column>

        <dx-column
            caption="Пункт ТУ по умолчанию"
            data-field="kod_num_tu_def"
            data-type="number"
            :min-width="200"
        >
            <dx-lookup
                :data-source="stagesList"
                value-expr="id"
                display-expr="name"
            />
        </dx-column>

        <dx-column
            caption="Приоритет"
            data-field="priority"
            data-type="number"
            :min-width="100"
        />

        <dx-column
            caption="Удельная стоимость в руб. (город)"
            data-field="sum_city"
            data-type="number"
            :min-width="150"
        >
            <dx-format
                type="fixedPoint"
                :precision="2"
            />
        </dx-column>

        <dx-column
            caption="Удельная стоимость в руб. (область)"
            data-field="sum_region"
            data-type="number"
            :min-width="150"
        >
            <dx-format
                type="fixedPoint"
                :precision="2"
            />
        </dx-column>

        <dx-column
            caption="Формула (SUM = удельная стоимость)"
            data-field="function_sum"
            data-type="string"
            :min-width="250"
        />

        <dx-column
            caption="Работа ТУ"
            data-field="name_tu"
            data-type="string"
            :min-width="800"
        />

        <dx-column
            caption="Работа ТЗ"
            data-field="name_tz"
            data-type="string"
            :min-width="800"
        />

        <template #objectTypeTemplate>
            <dx-select-box
                v-model="state.objectTypeId"
                :data-source="typesList"
                value-expr="id"
                display-expr="name"
                placeholder="Вид объекта"
                @valueChanged="changedObjectType($event)"
            />
        </template>
    </dx-data-grid>

    <footer-grid :totalCount = "state.totalCount"></footer-grid>
</template>

<script>
export default {
    name: 'akri-work-setting-view',
};
</script>

<script setup>
import { ref, onMounted, onBeforeMount } from 'vue';
import { DxSelectBox, DxButton } from 'devextreme-vue';
import { DxDataGrid, DxColumn, DxToolbar, DxItem, DxScrolling, DxLoadPanel, DxLookup, DxSorting, DxExport, DxFormat} from 'devextreme-vue/data-grid';

import {
    objetsList,
    workOwnerList,
    getObjectTypes,
    getCharacterList,
    getWorkSettings,
    getWorksList,
    getStagesTechnicalTask,
} from '@/views/arki/services/arki-character-service';
import FooterGrid from '@/components/grid-card-component/footer-grid.vue';

const
    state = ref({
        objectTypeId: null,
        totalCount: 0
        }),
    dataSource = ref([]),
    typesList = ref([]),
    worksList = ref([]),
    stagesList = ref([]),
    objects = ref([]),
    workOwner = ref([]),
    charactersLit = ref([]);

onBeforeMount(async () => {
    objects.value = objetsList;
    workOwner.value = workOwnerList;
    typesList.value = await getObjectTypes();
    worksList.value = await getWorksList();
    stagesList.value = await getStagesTechnicalTask();
});

onMounted(async () => {});

const changedObjectType = (e) => {
    reloadData();
}

const reloadData = async (reloadCharactersList = true) => {
    if (reloadCharactersList) {
        charactersLit.value = await getCharacterList(state.value.objectTypeId);
    }
    dataSource.value = await getWorkSettings(state.value.objectTypeId);
    state.value.totalCount = dataSource.value?.length || 0;
};

</script>

<style scoped>


</style>
